import React, { useState, useEffect } from 'react';

const BasicProductInfo = ({ productName, setProductName, productDesc, setProductDesc, reference, setReference, barcode, setBarcode, allReferences }) => {
  const [referenceError, setReferenceError] = useState('');
  const [isDuplicateReference, setIsDuplicateReference] = useState(false);

  // Check for duplicate reference whenever reference changes
  useEffect(() => {
    if (!reference || reference.trim() === '') {
      setReferenceError('');
      setIsDuplicateReference(false);
      return;
    }

    if (allReferences && allReferences.includes(reference.trim())) {
      setReferenceError('Cette référence existe déjà');
      setIsDuplicateReference(true);
    } else {
      setReferenceError('');
      setIsDuplicateReference(false);
    }
  }, [reference, allReferences]);

  return (
    <>
      <div className="sm:col-span-6">
        <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
          Nom du produit <span className="text-red-500">*</span>
        </label>
        <div className="mt-1">
          <input
            type="text"
            name="name"
            id="name"
            value={productName}
            onChange={(e) => setProductName(e.target.value)}
            className="block w-full focus:ring-[#174540] focus:border-[#174540] pl-3 py-2 sm:text-sm border border-gray-300 rounded-md"
            placeholder="ex: Smartphone Samsung Galaxy S21"
            required
          />
        </div>
      </div>

      <div className="sm:col-span-6">
        <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
          Description du produit
        </label>
        <div className="mt-1">
          <textarea
            name="description"
            id="description"
            rows="4"
            value={productDesc}
            onChange={(e) => setProductDesc(e.target.value)}
            className="block w-full focus:ring-[#174540] focus:border-[#174540] pl-3 py-2 sm:text-sm border border-gray-300 rounded-md"
            placeholder="Décrivez les caractéristiques et avantages du produit..."
          />
        </div>
      </div>

      <div className="sm:col-span-3">
        <label htmlFor="reference" className="block text-sm font-medium text-gray-700 mb-1">
          Référence <span className="text-red-500">*</span>
        </label>
        <div className="mt-1 relative">
          <input
            type="text"
            name="reference"
            id="reference"
            value={reference}
            onChange={(e) => setReference(e.target.value)}
            className={`block w-full focus:ring-[#174540] focus:border-[#174540] pl-3 py-2 sm:text-sm border ${
              isDuplicateReference ? 'border-red-500 ring-1 ring-red-500' : 'border-gray-300'
            } rounded-md`}
            placeholder="ex: REF-12345"
            required
          />
          {isDuplicateReference && (
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
          )}
        </div>
        {referenceError && (
          <p className="mt-1 text-sm text-red-600">{referenceError}</p>
        )}
      </div>

      <div className="sm:col-span-3">
        <label htmlFor="barcode" className="block text-sm font-medium text-gray-700 mb-1">
          Code à barres 
        </label>
        <div className="mt-1">
          <input
            type="text"
            name="barcode"
            id="barcode"
            value={barcode}
            onChange={(e) => setBarcode(e.target.value)}
            className="block w-full focus:ring-[#174540] focus:border-[#174540] pl-3 py-2 sm:text-sm border border-gray-300 rounded-md"
            placeholder="ex: 123456789012"
          />
        </div>
      </div>
    </>
  );
};

export default BasicProductInfo;